import { render, staticRenderFns } from "./SearchFilterTokens-v2.vue?vue&type=template&id=c8ba4646&scoped=true&"
import script from "./SearchFilterTokens-v2.vue?vue&type=script&lang=js&"
export * from "./SearchFilterTokens-v2.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c8ba4646",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('c8ba4646')) {
      api.createRecord('c8ba4646', component.options)
    } else {
      api.reload('c8ba4646', component.options)
    }
    module.hot.accept("./SearchFilterTokens-v2.vue?vue&type=template&id=c8ba4646&scoped=true&", function () {
      api.rerender('c8ba4646', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2uJIXrWpzu1S5/JS/comp/SearchFilterTokens-v2.vue"
export default component.exports